import { trim } from 'lodash';

export class RevertableState<T> {
    value: T = null;

    private _systemValue: T = null;
    private _originalValue: T = null;
    private _originalValueOverride: T = null;
    private _hasOriginalValueOverride = false;

    setSystemValue(value: T): void {
        this._systemValue = value;
    }

    setOriginalValue(value: T): void {
        this._originalValue = value;
        this._originalValueOverride = value;
        this._hasOriginalValueOverride = false;
    }

    get systemValue(): T {
        return this._systemValue;
    }

    get effectiveOriginalValue(): T {
        return this._hasOriginalValueOverride ? this._originalValueOverride : this._originalValue;
    }

    get valueDiffersFromSystem(): boolean {
        return !this._areEqual(this.value, this._systemValue);
    }

    get valueDiffersFromOriginal(): boolean {
        return !this._areEqual(this.value, this.effectiveOriginalValue);
    }

    revertToSystem(): T {
        this.value = this._systemValue;
        this._originalValueOverride = this._systemValue;
        this._hasOriginalValueOverride = true;
        return this.value;
    }

    revertToOriginal(): T {
        this.value = this._originalValue;
        this._originalValueOverride = this._originalValue;
        this._hasOriginalValueOverride = false;
        return this.value;
    }

    private _areEqual(left: T, right: T): boolean {
        if (left instanceof Date && right instanceof Date) {
            return left.getTime() === right.getTime();
        }

        if (this._isBlank(left) && this._isBlank(right)) {
            return true;
        }

        return left === right;
    }

    private _isBlank(value: T): boolean {
        return value == null || trim(String(value)) === '';
    }
}
